import map from 'lodash/map';
import { Route, Switch } from 'react-router-dom';

import { Consumer } from './context';

/**
 * Supports nested routes
 */
const NestedRoute = props => {
  const { renderKey, path, exact, components, routes, index } = props;

  if (routes?.length) {
    return (
      <Route
        path={path}
        exact={exact}
        render={routeProps =>
          map(routes, (r, i) => (
            <Route
              {...routeProps}
              path={r.path}
              exact={r.exact}
              component={r.components[renderKey]}
              key={`route-${index}-child-${i}`}
            />
          ))
        }
      />
    );
  } else {
    return <Route path={path} exact={exact} component={components[renderKey]} />;
  }
};

/**
 * Renders all the routes (and subroutes) that use the Layout specified by displayName
 */
export const LayoutRoutes = ({ location, renderKey, displayName }) => {
  return (
    <Consumer>
      {routes => (
        <Switch location={location}>
          {map(routes, (route, i) => {
            if (route.layout && route.layout.displayName === displayName) {
              return <NestedRoute renderKey={renderKey} {...route} index={i} key={`route-${i}`} />;
            }
          })}
        </Switch>
      )}
    </Consumer>
  );
};

// LayoutRoutes.propTypes = {
//   location: PropTypes.object,
//   renderKey: PropTypes.string.isRequired,
//   displayName: PropTypes.string.isRequired,
// };

// export default LayoutRoutes;
